import React, {FC, ReactNode} from "react"
import styled from "styled-components"
import Flex from "@irati/ui/src/Flex"
import Expander from "@irati/ui/src/Expander"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {H4} from "@irati/ui/src/Typography"
import {Toggle} from "@irati/ui/src/FormItem"
import {Card} from "@irati/ui/src/Layout"
import Spacing from "@irati/ui/src/Spacing"
import FormattedMessage, {useIntl} from "@irati/utils/lang"

interface Props {
  children: ReactNode
  text: string
  isChecked?: boolean
  setChecked?: () => void
  readOnly: boolean
}

const IconWrapper = styled.div`
  height: 24px;
  width: 24px;
  background-color: ${({theme}) => theme.colors.greys.grey03};
  border: 1px solid ${({theme}) => theme.colors.greys.grey12};
  border-radius: 100%;
`

const StyledIcon = styled(Icon)`
  path:first-child {
    fill: ${({theme}) => theme.colors.primary2};
  }
`

const ExpanderHeader: FC<Props> = ({renderProps: {showText, isChecked}}) => (
  <Flex alignContent="center" marginBottom={2}>
    {isChecked ? <StyledIcon icon={IconTypes.circleTickFill} size={24} /> : <IconWrapper />}
    <H4 marginLeft={1}>
      <FormattedMessage id={showText} />
    </H4>
  </Flex>
)

const ViewOrderExpander: FC<Props> = ({children, text, isChecked, setChecked, readOnly}) => {
  const {formatMessage} = useIntl()
  if (readOnly) {
    return (
      <Spacing marginTop={2} marginBottom={2}>
        <H4 marginBottom={2}>
          <FormattedMessage id={text} />
        </H4>
        {children}
      </Spacing>
    )
  }

  return (
    <Card marginTop={2} marginBottom={2}>
      <Expander Header={ExpanderHeader} isExpanded headerProps={{isChecked}} showText={text} fullWidth iconSize={16} flush>
        {children}
        {setChecked && (
          <Flex justifyContent="flex-end">
            <Toggle
              label={formatMessage({id: "admin.components.orderManagement.viewOrderExpender.label"})}
              checked={isChecked}
              onClick={setChecked}
            />
          </Flex>
        )}
      </Expander>
    </Card>
  )
}

export default ViewOrderExpander
